export var apiVersion;
(function (apiVersion) {
    apiVersion["V1"] = "v1";
    apiVersion["V2"] = "v2";
})(apiVersion || (apiVersion = {}));
;
//# sourceMappingURL=apiVersion.js.map